import { Component } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-powered-by',
  templateUrl: './powered-by.component.html',
  styleUrls: ['./powered-by.component.scss']
})
export class PoweredByComponent {
  public logoUrl: string = 'assets/images/info-logo.png';
  public isWhiteLogo: boolean = false;

  constructor(private router: Router) {
    this.onRouteChange();
  }

  onRouteChange() {
    this.router.events.subscribe((val) => {
      if (val instanceof NavigationEnd) {
        this.isWhiteLogo = val.url === '/login';
        this.logoUrl = this.isWhiteLogo ? 'assets/images/info-white-logo.png' : 'assets/images/info-logo.png';
      }
    });
  }
}
